(ns dre.components.select
  (:require
   ["antd" :refer [Select]]))

(defn select
  [props]
  [:> Select
   props])
